import { CreatableAsyncSelect, LookupOption } from '@/components';
import {
  mapResponsiblePersonValue,
  useResponsiblePersonsLookupSource,
} from '@/views';
import { TaskResponsiblePersonValue } from '@/core';
import { useMemo } from 'react';

interface Props {
  communityId?: string;
  initialValue?: TaskResponsiblePersonValue;
  className?: string;
  placeholder?: string;
}

export function ResponsiblePersonReadControl(props: Props) {
  const { communityId, initialValue, className, placeholder } = props;
  const responsiblePersonDataSource =
    useResponsiblePersonsLookupSource(communityId);
  const preloadInitial: LookupOption | undefined = useMemo(
    () =>
      initialValue
        ? {
            label: initialValue.label ?? initialValue.otherValue,
            value: mapResponsiblePersonValue(initialValue),
          }
        : undefined,
    [initialValue],
  );

  return (
    <CreatableAsyncSelect
      dataSource={responsiblePersonDataSource}
      preloadInitial={preloadInitial}
      preload
      className={className}
      placeholder={placeholder}
      value={preloadInitial!.value}
      disabled
      onChange={() => {}}
    />
  );
}
